import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ExamsResolutionAnswerKey } from '../exams-resolution/exams-resolution-answer-key';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Sheet, SheetBody, SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import usePermission from '@/hooks/usePermission';
import { TableCell, TableRow } from '@/components/ui/table';

export default function ExamMetricsUserListItem(props) {
  const { t } = useTranslation();
  const { examStudent, exam } = props;
  const navigate = useNavigate();

  const avatarImage = examStudent?.user?.image?.url;
  const avatarImageMemo = React.useMemo(() => avatarImage, [avatarImage]);
  const [showModal, setShowModal] = useState(false);

  const userAttempts = examStudent.user['question-books-users'][0];

  const getStatusBadge = status => {
    switch (status) {
      case 'waiting_correction':
        return { label: 'Aguardando correção', variant: 'warning' };
      case 'reviews':
        return { label: 'Em correção', variant: 'warning' };
      case 'approved':
        return { label: 'Aprovado', variant: 'success' };
      case 'disapproved':
        return { label: 'Reprovado', variant: 'danger' };
      case 'accepting_answers':
        return { label: 'Aceitando respostas', variant: 'neutral' };
      case 'review':
        return { label: 'Em correção', variant: 'warning' };
      default:
        return { label: '--', variant: 'neutral' };
    }
  };

  const hasPermissionToCorrect = usePermission('Corrigir questões discursivas', 'Provas e simulados');

  return (
    <>
      <TableRow>
        <TableCell>
          <div className="round-dg__user">
            <Link
              to={`/usuario/metricas/${examStudent?.user?.id}`}
              state={{ isRedirected: true }}
            >
              <AvatarWrapper
                src={avatarImageMemo}
                text={examStudent?.user?.name}
                className="size-9"
              />
            </Link>

            <div className="round-dg__user-inner">
              <h3
                className="round-dg__title font-bold text-primary-dark"
                title={examStudent?.user?.name}
              >
                <Link
                  to={`/usuario/metricas/${examStudent?.user?.id}`}
                  state={{ isRedirected: true }}
                >
                  {examStudent?.user?.name}
                </Link>
              </h3>
            </div>
          </div>
        </TableCell>

        <TableCell>{moment(userAttempts['finished-at']).format('DD/MM/YYYY') != 'Invalid date' ? moment(userAttempts['finished-at']).format('DD/MM/YYYY') : '--'}</TableCell>

        <TableCell>{exam?.['corrected-by'] || '--'}</TableCell>

        <TableCell>{parseFloat(userAttempts.score).toFixed(2) != 'NaN' ? parseFloat(userAttempts.score).toFixed(2) : '--'}</TableCell>

        <TableCell>
          <Badge
            variant={getStatusBadge(userAttempts?.['correction-status']).variant}
            size="xs"
          >
            {getStatusBadge(userAttempts?.['correction-status']).label}
          </Badge>
        </TableCell>

        {exam.visibility !== 'open' && (
          <TableCell>
            <Badge
              variant={getStatusBadge(userAttempts?.status).variant}
              size="xs"
            >
              {getStatusBadge(userAttempts?.status).label}
            </Badge>
          </TableCell>
        )}

        <TableCell>
          <div className="flex gap-2">
            {/* Botão de corrigir questão discursiva disponível se:
              - O usuário tiver permissão para corrigir questões discursivas (hasPermissionToCorrect = true)
              - A avaliação tiver questão discursiva (exam?.['has-discursive'] = true)
              - Estiver com status de aguardando correção ou em correção
            */}
            {hasPermissionToCorrect && exam?.['has-discursive'] && (userAttempts?.status === 'waiting_correction' || userAttempts?.status === 'review') && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate(`/correcao-discursiva/${examStudent?.user?.['question-books-users'][0]?.['question-book-id']}/${examStudent?.id}/${examStudent?.user?.['question-books-users'][0]?.id}`)}
              >
                {t('button.correctDiscursive')}
              </Button>
            )}
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowModal(true)}
            >
              {t('button.answerKey')}
            </Button>
          </div>
        </TableCell>
      </TableRow>

      <Sheet
        open={showModal}
        onOpenChange={setShowModal}
      >
        <SheetContent size="md">
          <SheetBody className="pb-6 pt-12">
            <ExamsResolutionAnswerKey
              examId={exam.id}
              examData={examStudent.user['question-books-users']}
              amountQuestions={exam['question-count']}
            />
          </SheetBody>
        </SheetContent>
      </Sheet>
    </>
  );
}
